const NAIVE_SECONDS = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/
const WHOLE_SECONDS = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/

/**
 * Milliseconds since the epoch for a timestamp the messaging API sent.
 *
 * The API has rendered timestamps both as a naive UTC wall clock
 * ("2026-10-01 20:28:34") and as ISO 8601 with an offset. `new Date` reads the
 * naive form as *local* time, so it is pinned to UTC here.
 */
export const epochMs = (value: string): number =>
  new Date(
    NAIVE_SECONDS.test(value) ? `${value.replace(" ", "T")}Z` : value
  ).getTime()

export const isAtOrBefore = (value: string, marker: string): boolean =>
  epochMs(value) <= epochMs(marker)

/**
 * The `before` cursor for the page older than the message created at `value`.
 *
 * A timestamp truncated to the second is earlier than the message it names,
 * so `created < value` would skip every message earlier in that same second.
 * Asking up to the next second returns them, and the rows already held are
 * dropped on merge. A full-precision timestamp is already exact.
 */
export const olderPageCursor = (value: string): string => {
  if (!WHOLE_SECONDS.test(value)) return value
  const next = new Date(epochMs(value) + 1000).toISOString()
  return `${next.slice(0, 10)} ${next.slice(11, 19)}`
}
